import React from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'
import Fr from './Fr'

const Wrap = styled.ul`
    display: flex;
    flex-direction: column;
    gap:24px;
    align-items: flex-start;
    padding: 1rem 10px;
    width: calc(100% - 20px);
    position: fixed;
    z-index: 10;
    background: white;
    height: 100%;
`
const Nav = styled.li`
a {
    font-family: 'Outfit';
font-style: normal;
font-weight: 300;
font-size: 24px;
line-height: 36px;
color: #39394C;
}
font-family: 'Outfit';
font-style: normal;
font-weight: 300;
font-size: 24px;
line-height: 36px;
color: #39394C;
`
const Email = styled.div`
    display: flex;
    flex-direction: column;
    gap:2px;
    margin-top: 3rem;
`
const EmailUs = styled.h3`
    font-family: 'Outfit';
font-style: normal;
font-weight: 600;
font-size: 24px;
line-height: 0;
color: #39394C;

`
const StratProject = styled(Link)`
    display: flex;
flex-direction: row;
justify-content: center;
align-items: center;
padding: 20px 0;
font-family: 'Outfit';
font-style: normal;
font-weight: 400;
font-size: 14px;
line-height: 20px;
/* identical to box height, or 143% */

text-align: center;
margin-top: 2rem;
/* White */

color: #FFFFFF;
width: 100%;
/* Primary */

background: #FF4C55;
border-radius: 60px;
`
const NavElements= styled.div`
    display:flex;
    flex-direction: row;
    align-items: center;
    flex: 1;
    justify-content: end;
    gap:24px;
    margin: 13px 0;
    @media screen and (max-width:740px) {
        display:none;
    }
`
function Menu() {
    let str = ''
    if(typeof window !== 'undefined') {
        let location = window.location.pathname
        str = location.replace(/^\/([^\/]*).*$/, '$1')
        let last_segment  = window.location.pathname.split('/');
    }
  return (
    <Wrap>
          {str == 'fr-fr'? 
          (
            <>
              <Nav><Link to='/fr-fr/a-propos'>A propos</Link></Nav>
              <Nav><Link to='/fr-fr/nos-services'>Nos Services</Link></Nav>
              <Nav><Link to='/fr-fr/resource'>Nos projets</Link></Nav>
              <Nav><Link to='/fr-fr/nos-contacter'>Nous contacter</Link></Nav>
            </>
          )
          :
          (
            <>
        <Nav><Link to='/about'>About</Link></Nav>
        <Nav><Link to='/services'>Our Services</Link></Nav>
        <Nav><Link to='/en-us/resource'>Our work</Link></Nav>
        <Nav><Link to='/contact'>Contact Us</Link></Nav>
            </>
          )
          
          }   
          
     
        <Fr />
        <Email>
        {str == 'fr-fr'? 
<>
<EmailUs>
Envoyez-nous un courriel
            </EmailUs>
            <Nav>
                contact@visionair.digital
            </Nav>
</>
        :
<>
<EmailUs>
                Email us :
            </EmailUs>
            <Nav>
                contact@visionair.digital
            </Nav>
</>
        }
           
        </Email>
        <StratProject to={str =='fr-fr' ? '/fr-fr/nos-contacter': '/contact'}>
       {str == 'fr-fr' ? "J'ai un projet" : "Start project"}
        </StratProject>
    </Wrap>
  )
}

export default Menu